var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$config.enableShop)?_c('AnimatedLogo'):_vm._e(),(_vm.$config.enableShop)?_c('Slides'):_vm._e(),_c('LatestReleases'),_c('LatestVideos'),_c('ComingEvents'),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }